import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/Digital.css";
import logo from "../assets/images/teteklogo-removebg-preview.png";

const Digital = () => {
  const navigate = useNavigate();

const startTest = (topic) => {
  navigate("/ques", { state: { topic } }); // 👈 pass topic as state
};

  return (
    <div className="digital__container">
      <header className="digital__header">
        <div className="digital__company-name">
          <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
        </div>
        <div className="digital__title">Design Tools Mock Test</div>
        <div className="digital__subtitle">
          Select a design software to begin your test
        </div>
      </header>

      <div className="digital__card-grid">
        <div className="digital__card" onClick={() => startTest("photoshop")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/732/732228.png"
            alt="Photoshop Icon"
            className="digital__card-image"
          />
          <h2 className="digital__card-title">Photoshop</h2>
          <button className="digital__start-btn">Start Test</button>
        </div>

        <div className="digital__card" onClick={() => startTest("flash")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/226/226775.png"
            alt="Flash Icon"
            className="digital__card-image"
          />
          <h2 className="digital__card-title">Flash</h2>
          <button className="digital__start-btn">Start Test</button>
        </div>

        <div className="digital__card" onClick={() => startTest("canva")}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/906/906175.png"
            alt="Canva Icon"
            className="digital__card-image"
          />
          <h2 className="digital__card-title">Canva</h2>
          <button className="digital__start-btn">Start Test</button>
        </div>
      </div>

      <footer className="digital__footer">© 2025 Vienstereoptic. All rights reserved.</footer>
    </div>
  );
};

export default Digital;
